<template>
  <div class="confirmation">    
    <div class="appointment-info"> 
      <div class="appointment">
        <div class="message">{{ response.message }}</div>
        <div class="date" v-html="response.date" />
        <h3>Primary Guest Info:</h3>
        <div class="primary" v-html="response.primary" />
        <div class="guests" v-if="response.guests !== ''">
          <h3>Additional Guests Info:</h3>
          <div class="guest-info" v-html="response.guests" />
        </div>
        <Button
          text="Close Now"
          link=""          
          class="book"
          alternateTheme
          @click="closeIframe"
        />
      </div>
    </div>
  </div>
</template>

<script>
//can close the iframe from the child only because it is same origin
//frameElement.parentNode.removeChild(frameElement)
import Button from "@/components/Button";
export default {
  name: "Confirmation",
  components: {
    Button,
  },
  props: {
    response:Object
  },
  data() {
    return {
    /*  
      response: {
        message: "Richard, you have successfully booked an appointment!",
        date: "June 24, 2022 &bull; 8:30 am",
        primary:
          "<p class='full-name'>Test F Tesxt L (test d)</p> <p class='email'>richard@channel1media.com</p> <p class='phone'>6546546565</p> <p class='company'>Company</p> <p class='address'>65 Address</p> <p class='notes'>ntoes</p>",
        guests:
          "<p class='guest'>Gf Gl(richard@channel1media.com)</p><p class='guest'>Gf Gl(richard@channel1media.com)</p>",
      },
      /* */
    };
  },
  mounted() {
    window.parent.postMessage('booked', '*');
  },
  methods : {
    closeIframe() {
        window.parent.postMessage('closed', '*');
    }
  }
};
</script>

<style lang="scss" scoped>
.book {  
  width: calc(100% - 100px);
  @media (min-width: 1000px) {
    width: auto;
    margin-top:2rem;
  }
}
.confirmation {
  flex-direction: column;
  color: var(--white);  
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
  border-radius: 6px;
  font-size: 1rem;
  overflow:hidden;
  > div {
    font-size:1rem;
    background: #000000;    
  }
}

.date {
  color: var(--accent);
  font-size: 2rem;
  padding: 20px 0;
  text-transform: uppercase;
}
h3 {
  margin-bottom: 0;
  color: var(--accent);
}
.primary {
  :deep() {
    p {
      margin: 8px 0;
      font-size: 1rem;
    }
  }
}
.guest-info {
  :deep() {
    .guest {
      font-size: 1rem;
      margin: 4px 0;
      &:first-child {
        margin-top: 1em;
      }
    }
  }
}
.appointment-info {
  display: flex;
  font-size: 1.25rem;
  flex-direction: column;
  background: var(--dark-red);    
  @media (min-width: 1000px) {
    flex-direction: row;
  }
  > div {
    padding: 15px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }  
  .appointment {
    background: var(--dark-red);
    padding: 75px 50px;
    align-items: center;
    position: relative;
    text-align: center;
  }
}
h2 {
  color:var(--black);
  text-align: center;
  padding: 10px;
  margin: 0;
  font-size:1rem;  
  text-transform: uppercase;
}
</style>